/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum ExperimentalAutomationRuleState {
  DISABLED = "DISABLED",
  ENABLED = "ENABLED",
  NEW = "NEW",
}

//==============================================================
// END Enums and Input Objects
//==============================================================

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: AutomationRuleSummary
// ====================================================

export interface AutomationRuleSummary_experimentalAutomationRuleSummary_componentSummaries {
  componentName: string;
  component: string;
  type: string;
}

export interface AutomationRuleSummary_experimentalAutomationRuleSummary {
  id: string;
  name: string;
  authorAccountId: string;
  ruleState: ExperimentalAutomationRuleState;
  componentSummaries: AutomationRuleSummary_experimentalAutomationRuleSummary_componentSummaries[];
}

export interface AutomationRuleSummary {
  experimentalAutomationRuleSummary: AutomationRuleSummary_experimentalAutomationRuleSummary | null;
}

export interface AutomationRuleSummaryVariables {
  ruleId: string;
  cloudId: string;
  automationStack: string;
  spaceId: string;
}
